
import { defineComponent } from 'vue'

export default defineComponent({
    name: "DotSpinner",
    props: {
        dots: {
            type: Number,
            default: 5
        },
        color: {
            type: String,
            required: false
        }
    }
})
